import React, { useEffect, useRef, useState } from "react";
import { useScript } from "../../util/customHooks";

import './HLSJSPlayer.css';
import { getConfiguration } from '../../utils/configuration';

export default function HLSJSPlayer(props) {
    const conf = getConfiguration();
    const status = useScript(props.scriptSrc || 'https://cdn.jsdelivr.net/npm/hls.js@latest',true);
    const streamSourceUrl = props.streamSource;
    const [playerStarted,setPlayerStarted] = useState(false);
    const [isErr,setIsErr] = useState(false);
    const [errMsg,setErrMsg] = useState(null);
    const videoRef = useRef();

    useEffect(() => {
        if (typeof window.Hls !== 'undefined' && status == 'ready'  && streamSourceUrl && !playerStarted ) {
            const Hls = window.Hls;
            try {
                var video = videoRef.current;
                if(Hls?.isSupported()) {
                    var hls = new Hls();
                    hls.loadSource(streamSourceUrl);
                    hls.attachMedia(video);
                    hls.on(Hls.Events.MANIFEST_PARSED,function() {
                    video.play();
                    });
                }
                // hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
                // When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element throught the `src` property.
                // This is using the built-in support of the plain video element, without using hls.js.
                else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    video.src = streamSourceUrl;
                    video.addEventListener('canplay',function() {
                    video.play();
                    });
                }
                setPlayerStarted(true);
            }catch(err){
                setIsErr(true);
                console.log(err);
            }
        }
    }, [status])
    
    const controlsList = conf.iwh?"nofullscreen":"";

    return (
        <>
        {isErr?
                errMsg || 'Error loading stream, something went wrong'
        :
            <>{streamSourceUrl && 
                <>
                {!playerStarted? 'Starting player...' :''}
                <video playsInline muted autoPlay ref={videoRef} controls={true} controlsList={controlsList} className="hlsjs-live-stream-video-player" ></video>
                </>
            
            }
            </>
        }
        </>
    )

}